export const BAR_CHART_HEIGHT = 350;
